import SignUp from "container/Signup";

export const JudgeSignup = () => {
  return <SignUp isJudge={true} />;
};
